import ModulePanel from "./ModulePanel";
import { resolveOpenTransactionId } from "../api/homePageApi";
import BrandAuditDetailPane from "./BrandAuditDetailPane";

import { ENTITY_LABELS } from "../../../utils/labelMapping";

const MODULE_KEY = "brandAudit";
// Getter: resolved at render time so per-customer label overrides apply
const getModuleLabel = () => `Brand ${ENTITY_LABELS.audit}`;

/**
 * Deep link to the real Brand Audit page for one record — same
 * ?type=&id=&user_id=&customer_id= shape BrandAudit/Share/Share.js builds
 * and BrandAudit.js itself reads on load to reopen a specific transaction
 * (BrandAudit.js:1037-1039), same convention as Discovery's own deep link.
 */
function buildFullViewUrl(record, { userId, customerId }) {
  if (!record?.transactionId || !userId) return null;
  const params = new URLSearchParams({
    // Same case fix as Discovery's own buildFullViewUrl — record.type is
    // "Brand"/"Product" (capitalized), BrandAudit.js compares this query
    // param lowercase everywhere it drives the radio button/pillars table.
    type: (record.type || "brand").toLowerCase(),
    id: resolveOpenTransactionId(record),
    user_id: userId,
    customer_id: customerId,
  });
  return `/luminaire/brand-audit?${params.toString()}`;
}

export default function BrandAuditModule() {
  return (
    <ModulePanel
      moduleKey={MODULE_KEY}
      moduleLabel={getModuleLabel()}
      weightTag="multi-combination · point-in-time"
      DetailPane={BrandAuditDetailPane}
      buildFullViewUrl={buildFullViewUrl}
    />
  );
}
